import { auth, functions, firebase } from '@/vendors/firebase/firebase';
/* eslint-disable */
const ls = require('local-storage')
import axios from 'axios';

export default {
  async getUserToken() {
    return auth.currentUser.getIdToken(true);
  },
  async isAuthenticated() {
    return auth.currentUser.getIdToken(true).then((token) => !!token);
  },
  async loginWithCredentials(email, password) {
    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
    const { user } = await auth.signInWithEmailAndPassword(email, password);
    return user;
  },
  async loginWithCustomToken(token) {
    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
    const { user } = await auth.signInWithCustomToken(token);
    return { user };
  },
  async getCurrentCustomTokenUserInfo() {
    try {
      const { claims } = await auth.currentUser.getIdTokenResult();
      return claims.userInfo;
    } catch {
      return null;
    }
  },
  async logout() {
    return auth.signOut();
  },
  async listenUserState(cb) {
    return new Promise((resolve) => {
      return auth.onAuthStateChanged((user) => {
        if (cb) { cb(user); }
        resolve(user);
      });
    });
  },
  async sendResetPasswordRequest(newPassword, userId) {
    const shopToken = ls.get('shopToken');
    const res = await axios.post(process.env.VUE_APP_RESET_PASSWORD_REQUEST_ENDPOINT, {
      newPassword,
      userId,
    }, {
      headers: { 'shop-token': shopToken },
    });
    return res;
  },
  async changePassword(newPassword) {
    const { data } = await functions.httpsCallable('updateUserPassword')({
      password: newPassword,
    });
    return data;
  },
};
